import { Check } from "lucide-react";

export function ActionItem({ label, checked, onToggle, testId, color = "#E32C8C" }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onToggle}
      className="w-full flex items-start gap-3 text-left py-3 px-3.5 rounded-xl bg-white/[0.05] hover:bg-white/[0.1] transition-all active:scale-[0.99]"
    >
      <span
        className="mt-0.5 w-6 h-6 rounded-full flex items-center justify-center shrink-0 border-2 transition-all"
        style={{
          borderColor: color,
          backgroundColor: checked ? color : "transparent",
        }}
      >
        {checked && <Check className="w-4 h-4 text-white" strokeWidth={3} />}
      </span>
      <span
        className={`text-[15px] leading-snug pt-0.5 transition-all ${
          checked ? "line-through text-[#EAC6D9]/60" : "text-[#F6DCEA]"
        }`}
      >
        {label}
      </span>
    </button>
  );
}
